import React, { forwardRef, useId } from 'react';

const BaseTextarea = forwardRef(function BaseTextarea(
  {
    id,
    name,
    label,
    value = '',
    onChange,
    onBlur,
    placeholder,
    required = false,
    error,
    helperText,
    disabled = false,
    loading = false,
    valid = false,
    rows = 3,
    className = '',
    wrapperClassName = '',
    ...rest
  },
  ref
) {
  const generatedId = useId();
  const inputId = id || `ui-textarea-${generatedId}`;
  const errorId = `${inputId}-error`;
  const helperId = `${inputId}-helper`;

  const stateClass = error
    ? 'ui-textarea--invalid'
    : valid
      ? 'ui-textarea--valid'
      : '';

  const describedBy = [
    error ? errorId : null,
    helperText ? helperId : null,
  ]
    .filter(Boolean)
    .join(' ') || undefined;

  return (
    <div className={`ui-field ${wrapperClassName}`.trim()}>
      {label && (
        <label htmlFor={inputId} className="ui-field__label">
          {label}
          {required && <span className="ui-field__required">*</span>}
        </label>
      )}

      <textarea
        ref={ref}
        id={inputId}
        name={name}
        value={value ?? ''}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled || loading}
        required={required}
        rows={rows}
        aria-invalid={Boolean(error)}
        aria-describedby={describedBy}
        className={['ui-textarea', stateClass, loading ? 'ui-textarea--loading' : '', className]
          .filter(Boolean)
          .join(' ')}
        {...rest}
      />

      <div className="ui-field__error-slot">
        {error ? (
          <span id={errorId} className="ui-field__error" role="alert">
            {error}
          </span>
        ) : null}
      </div>

      {helperText && !error && (
        <p id={helperId} className="ui-field__helper">
          {helperText}
        </p>
      )}
    </div>
  );
});

export default BaseTextarea;
